import { Stack } from 'src/design/atoms/Stack';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useOrganization } from 'src/hooks/useOrganization';
import { Header } from 'src/design/organisms/Header';
import { AdminStatsSections } from 'src/routes/Settings/AIAssistant/components/AdminStatsSections';
import { ConversationsTable } from 'src/routes/Settings/AIAssistant/components/ConversationsTable';
import { DateRangeFilter } from 'src/routes/Settings/AIAssistant/components/DateRangeFilter';
import { SqlAuditTable } from 'src/routes/Settings/AIAssistant/components/SqlAuditTable';
import { UserMemorySection } from 'src/routes/Settings/AIAssistant/components/UserMemorySection';
import { useAdminStats } from 'src/routes/Settings/AIAssistant/hooks/useAdminStats';
import { useDefaultDateRange } from 'src/routes/Settings/AIAssistant/hooks/useDefaultDateRange';

export const AIAssistantUserDetail: React.FC = () => {
  const params = useParams<{ userId: string }>();
  const userId = Number(params.userId);
  const { users } = useOrganization();
  const [dateRange, setDateRange] = useDefaultDateRange();
  const { overview, daily, loading } = useAdminStats(userId, dateRange);

  const userName =
    users.find((u) => u.id === userId)?.fullName ?? params.userId ?? 'User';

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'F.I.R.E.', href: '/settings/ai-assistant' },
            { text: userName },
          ],
        }}
        title={userName}
        helpText="Usage, cost, conversations, SQL queries run on behalf of this user, and the user's memory notes."
      />
      <Stack gap="md">
        <DateRangeFilter value={dateRange} onChange={setDateRange} />
        <AdminStatsSections
          overview={overview}
          daily={daily}
          loading={loading}
          dateRange={dateRange}
          userId={userId}
        />
        <ConversationsTable userId={userId} dateRange={dateRange} />
        <SqlAuditTable userId={userId} dateRange={dateRange} />
        <UserMemorySection userId={userId} />
      </Stack>
    </>
  );
};
